<template>
	<div class="gb-cell gb-term lighten-3 primary" tile v-bind:class="styleDayWeekday" color="primary" v-bind:style="styleUnit">
		<template v-if="term.isHoliday()">
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<span v-on="on">{{ term.caption }}</span>
			</template>
		<span>{{ term.getHolidayName() }}</span>
		</v-tooltip>
		</template>
		<template v-else>
			<span>{{ term.caption }}</span>
		</template>
	</div>
</template>
<script>
import { UNIT_WIDTH } from '../data/Const';
export default {
	name: 'GBTerm',
	props:["term"],
	computed: {
		styleDayWeekday: function() {
			let classes = new Array();
			if ((this.term.weekDayNum == 0) || this.term.isHoliday()){
				classes.push("red--text");
			} else if (this.term.weekDayNum == 6) {
				classes.push("blue--text text--darken-3");
			} else {
				classes.push("white--text");
			}
			return classes;
		},
		styleUnit: function() {
			return {
				width: UNIT_WIDTH.DAY + 'px',
			};
		},
	},
}
</script>
<style>
	.gb-term {
		display: inline-block;
		height: 100%;
		text-align: center;
	}
</style>
